<template>
    <div class="mt-0.5 mx-4 mb-4">
        <div v-if="breakdown.materials">
            <!-- Materials. -->
            <div class="flex border -mb-px border-gray-200 bg-blue-50 rounded-t-lg">
                <div class="flex-1 text-xs font-semibold px-2 py-1.5">Material & Supplier</div>
                <div class="w-28 -ml-px text-xs font-semibold px-2 py-1.5">Cost</div>
                <div class="w-20 -ml-px text-xs font-semibold px-2 py-1.5 text-right">Quantity</div>
                <div class="w-28 -ml-px text-xs font-semibold px-2 py-1.5 text-right">Total cost</div>
            </div>
            <div v-if="this.costData.materials.size === 0"
                 class="bg-gray-50 border border-gray-200 p-4 text-gray-500 italic text-center mt-0 -mb-px">
                Has no Material items
            </div>
            <div v-else>
                <estimate-cost-list-material-row
                    v-for="(material, index) in Array.from(costData.materials, ([name, value]) => value)"
                    :estimate="estimate"
                    :key="material.id"
                    :item="material"
                    :store="store"
                    :type="type"
                    @updateMaterial="(e) => $emit('updateMaterial',e)"
                ></estimate-cost-list-material-row>
            </div>
        </div>
        <div v-if="breakdown.labourRates">
            <!-- Labour Rates. -->
            <div class="flex border -mb-px border-gray-200 bg-blue-50 " :class="breakdown.materials?'':'rounded-t-lg'">
                <div class="flex-1 text-xs font-semibold px-2 py-1.5">Labour</div>
                <div class="w-28 -ml-px text-xs font-semibold px-2 py-1.5">Rate</div>
                <div class="w-20 -ml-px text-xs font-semibold px-2 py-1.5 text-right">Quantity</div>
                <div class="w-28 -ml-px text-xs font-semibold px-2 py-1.5 text-right">Total cost</div>
            </div>
            <div v-if="this.costData.labour.size === 0"
                 class="bg-gray-50 border border-gray-200 p-4 text-gray-500 italic text-center mt-0 -mb-px">
                Has no Labour items
            </div>
            <div v-else>
                <estimate-cost-list-labour-row
                    v-for="(labour, index) in Array.from(costData.labour, ([name, value]) => value)"
                    :estimate="estimate"
                    :key="labour.id"
                    :item="labour"
                    :store="store"
                    :type="type"
                    @updateLabour="(e) => $emit('updateLabour',e)"
                ></estimate-cost-list-labour-row>
            </div>
        </div>
        <div v-if="breakdown.fixedCosts">
            <!-- Fixed Cost Rates. -->
            <div class="flex border -mb-px border-gray-200 bg-blue-50 "
                 :class="breakdown.materials || breakdown.labourRates?'':'rounded-t-lg'">
                <div class="flex-1 text-xs font-semibold px-2 py-1.5">Fixed Cost</div>
                <div class="w-20 -ml-px text-xs font-semibold px-2 py-1.5">UoM</div>
                <div class="w-28 -ml-px text-xs font-semibold px-2 py-1.5">Rate</div>
                <div class="w-20 -ml-px text-xs font-semibold px-2 py-1.5 text-right">Quantity</div>
                <div class="w-28 -ml-px text-xs font-semibold px-2 py-1.5 text-right">Total cost</div>
            </div>
            <div v-if="this.costData.fixedCosts.size === 0"
                 class="bg-gray-50 border border-gray-200 p-4 text-gray-500 italic text-center mt-0 -mb-px">
                Has no Fixed Cost items
            </div>
            <div v-else>
                <estimate-cost-list-fixed-cost-row
                    v-for="(fixedCost, index) in Array.from(costData.fixedCosts, ([name, value]) => value)"
                    :estimate="estimate"
                    :key="fixedCost.id"
                    :item="fixedCost"
                    :store="store"
                    :type="type"
                    @updateFixedCost="(e) => $emit('updateFixedCost',e)"
                ></estimate-cost-list-fixed-cost-row>
            </div>
        </div>
        <!-- Total lines. -->
        <div class="border border-gray-200 bg-blue-50 -mb-px"
             :class="(breakdown.materials || breakdown.labourRates || breakdown.fixedCosts)?'':'rounded-t-lg'">
            <div class="flex text-right">
                <div class="flex-1 text-xs px-2 py-1">Material Total:</div>
                <div class="w-28 -ml-px text-xs px-2 py-1">{{ materialTotal() | toCurrency }}</div>
            </div>
        </div>
        <div class="border border-gray-200 bg-blue-50 -mb-px">
            <div class="flex text-right">
                <div class="flex-1 text-xs px-2 py-1">Labour Total:</div>
                <div class="w-28 -ml-px text-xs  px-2 py-1">{{ labourTotal() | toCurrency }}</div>
            </div>
        </div>
        <div class="border border-gray-200 bg-blue-50 -mb-px">
            <div class="flex text-right">
                <div class="flex-1 text-xs px-2 py-1">Fixed Costs Total:</div>
                <div class="w-28 -ml-px text-xs px-2 py-1">{{ fixedCostsTotal() | toCurrency }}</div>
            </div>
        </div>
        <div class="border border-gray-200 bg-blue-50 rounded-b-lg -mb-px">
            <div class="flex text-right">
                <div class="flex-1 text-sm font-semibold px-2 py-1">Cost Total:</div>
                <div class="w-28 -ml-px text-sm font-semibold px-2 py-1">
                    {{ (materialTotal() + labourTotal() + fixedCostsTotal()) | toCurrency }}
                </div>
            </div>
        </div>

    </div>
</template>
<script>


export default {
    components: {},
    props: {
        estimate: Object,
        costData: Object,
        store: Object,
        type: String,
        breakdown: Object,
    },
    data() {
        return {}
    },
    mounted() {
    },
    methods: {
        materialTotal() {
            return 0 + Array.from(this.costData.materials, ([name, value]) => value).reduce((a, material) => a + (material.cost * material.quantity), 0);
        },
        labourTotal() {
            return 0 + Array.from(this.costData.labour, ([name, value]) => value).reduce((a, labour) => a + (labour.rate * labour.quantity), 0);
        },
        fixedCostsTotal() {
            return 0 + Array.from(this.costData.fixedCosts, ([name, value]) => value).reduce((a, fixedCost) => a + (fixedCost.rate * fixedCost.quantity), 0);
        },

    }
}
</script>
